import pageInfo from './pageInfo';

const root = {
	pageInfo
};

export default root;
